<template>
    <div class="container">
      <div class="pokeball"></div>
    </div>
</template>
<script>
    export default {
        name: 'Pokeball'
    }
</script>
<style lang="scss" scoped>
  @import '@/assets/sass/components/Pokeball.scss'
</style>